import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'dynamica-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [TranslatePipe]
})
export class FooterComponent {

  readonly currentYear = new Date().getFullYear();

}
